module.exports = __webpack_public_path__ + "img/equipment-specification.b1d15269.svg";